<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { apiClient } from '@api/client'
import { useAuth } from '@shared/composables/useAuth'

const router = useRouter()
const { selectUser } = useAuth()

const username = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')

async function login() {
  if (!username.value || !password.value) {
    error.value = '请输入用户名和密码'
    return
  }

  loading.value = true
  error.value = ''

  try {
    await apiClient.post('/api/auth/login', {
      username: username.value,
      password: password.value
    })
    selectUser(username.value)
    router.replace('/')
  } catch {
    error.value = '用户名或密码错误'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="w-full max-w-sm mx-auto">
    <div class="text-center mb-lg">
      <h1 class="text-2xl font-bold text-text-primary">不系舟</h1>
      <p class="text-sm text-text-secondary mt-xs">请登录</p>
    </div>

    <form @submit.prevent="login" class="space-y-md">
      <div>
        <label class="block text-sm text-text-secondary mb-xs">用户名</label>
        <input
          v-model="username"
          type="text"
          autocomplete="username"
          class="w-full px-md py-sm rounded-lg border bg-background-primary text-text-primary
                 focus:outline-none focus:ring-2 focus:ring-brand-primary"
          :style="{ borderColor: 'var(--surface-glass-border)' }"
        />
      </div>

      <div>
        <label class="block text-sm text-text-secondary mb-xs">密码</label>
        <input
          v-model="password"
          type="password"
          autocomplete="current-password"
          class="w-full px-md py-sm rounded-lg border bg-background-primary text-text-primary
                 focus:outline-none focus:ring-2 focus:ring-brand-primary"
          :style="{ borderColor: 'var(--surface-glass-border)' }"
        />
      </div>

      <p v-if="error" class="text-sm text-red-500">{{ error }}</p>

      <button
        type="submit"
        :disabled="loading"
        class="w-full px-md py-sm rounded-lg text-sm font-medium transition-colors
               bg-brand-primary text-white hover:bg-brand-primary/90
               disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {{ loading ? '登录中...' : '登录' }}
      </button>
    </form>
  </div>
</template>
